// frontend/src/components/common/ImportButton.jsx
//
// The import affordance, labelled by what the import actually does.
//
// "Import" means "bring in things that aren't here yet". Where the upload
// cannot create anything, the screen says "Bulk update" instead — see the
// Bulk update entry in i18n/terminology.js.
//
// The label comes from the server's import mode (useTabularEntity), never from
// a page prop, so the wrong word cannot be typed on the wrong screen. That is
// the same rule the dialog follows for its copy; this is its front door.
//
// Pairs with GridExportButton, which owns the other half of the round trip.

import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ICON, ImportIcon } from '../../icons';
import { useTabularEntity } from '../../hooks/useTabularEntity';

/**
 * @param {Object}   props
 * @param {string}   props.entityKey - the register's key ('items', ...)
 * @param {Function} props.onClick
 */
export default function ImportButton({ entityKey, onClick }) {
  const { t } = useTranslation();
  const { updateOnly, isLoading, error } = useTabularEntity(entityKey);

  return (
    <Button
      variant="outlined"
      startIcon={<ImportIcon size={ICON.md} />}
      onClick={onClick}
      // Until the server has said what this import does, the button cannot
      // say either — and a failed read leaves it unusable rather than
      // guessing a label the dialog would then contradict.
      disabled={isLoading || !!error}
    >
      {t(updateOnly ? 'bulkImport.bulkUpdate' : 'bulkImport.import')}
    </Button>
  );
}
